module.exports = __webpack_public_path__ + "img/nextStepHover2.c8543b4a.png";